// @ts-check

import { api } from '@/api'
import { OWNER_TYPE_COMPANY } from '@/core/constants'

/**
 * @deprecated Use getProductsNew instead
 */
export const getProducts = async (params, page, owner) => {
  const requestBody = { params: { ...params } }

  if (page) {
    requestBody.params = { page }
  }

  if (owner) {
    requestBody.params.owner = owner
  }

  return api.get('products', requestBody)
}

/**
 * @param {*} params
 * @returns {Promise<ProductResource[]>}
 */
export const getProductsNew = async (params) => {
  const res = await api.get('products', {
    params
  })
  return res.data
}

/**
 * @param {number} productId
 * @returns {Promise<ProductResource>}
 */
export const getProduct = async (productId) => {
  const { data: product } = await api.get(`products/${productId}`)
  return product
}

export const getCompanyProducts = async (params) =>
  getProductsNew({
    ...params,
    owner: [OWNER_TYPE_COMPANY]
  })

/**
 * @param {*} product
 * @returns {Promise<ProductResource>}
 */
export const createProduct = async (product) => {
  const { data } = await api.post('products', product)
  return data
}

/**
 * @param {ProductResource['product']['id']} productId
 * @param {*} product
 * @returns {Promise<ProductResource>}
 */
export const updateProduct = async (productId, product) => {
  const { data } = await api.put(`products/${productId}`, product)
  return data
}
